import React, { useMemo } from "react";
import { withCurrentUserQuery } from "../../../../api/queries/useUserQuery";
import DowngradeEpcsButton from "./DowngradeEpcsButton";
import UpgradeEpcsButton from "./UpgradeEpcsButton";

const UpgradeDowngradeEpcsButton = ({
  data,
  setLocalPrescribers,
  currentUserQuery,
}) => {
  const isDowngrade = data.state.plan_type?.toLowerCase() === "epcs";

  const initialFormValues = {
    dea: data.dea || "",
    npi: data.npi || "",
    licenseNumber: data.license_number || "",
  };

  const isMainAdmin = useMemo(
    () => currentUserQuery?.data?.isMainAdmin || false,
    [currentUserQuery?.data],
  );

  return isMainAdmin ? (
    <>
      {isDowngrade ? (
        <DowngradeEpcsButton
          id={data.id}
          setLocalPrescribers={setLocalPrescribers}
        />
      ) : (
        <UpgradeEpcsButton
          id={data.id}
          initialFormValues={initialFormValues}
          setLocalPrescribers={setLocalPrescribers}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default withCurrentUserQuery(UpgradeDowngradeEpcsButton);
